import cartItemApi from '@/api/cartItem';
import { loadEntity, enhanceOrAdd } from '@/helpers/utility';

const state = {
    byId: {},
    genericItemSuggestions: [],
};

const actions = {
    async createCartItem({ dispatch, commit, rootState }, { cartItem }) {
        cartItem = await cartItemApi.create(cartItem);
        loadEntity({ cartItem });
        return cartItem;
    },
    async updateCartItem({ dispatch }, { cartItem }) {
        cartItem = await cartItemApi.update(cartItem);
        loadEntity({ cartItem });
        return cartItem;
    },
    async updateCartItemApproval({ commit, dispatch }, { cartItem, value }) {
        let cartItemUpdate = {
            id: cartItem.id,
            is_approved: value,
        };

        // Update the UI immediately
        commit('UPDATE_CARTITEM', { cartItem: cartItemUpdate });
        cartItem = await cartItemApi.update(cartItemUpdate);
        loadEntity({ cartItem });
        return cartItem;
    },
    async deleteCartItem({ commit, dispatch }, { cartItem }) {
        cartItem = await cartItemApi.delete(cartItem);
        commit('REMOVE_CARTITEM', { cartItem });
        loadEntity({ cart: cartItem.cart });
        return cartItem;
    },
    async getGenericItemSuggestions({ commit }) {
        let suggestions = await cartItemApi.getGenericItemSuggestions();
        commit('UPDATE_GENERICITEMSUGGESTIONS', { suggestions });
    },
};

const mutations = {
    LOAD_ENTITIES(state, { cartItems }) {
        if (cartItems)
            Object.values(cartItems).forEach(cartItem => enhanceOrAdd(state.byId, cartItem.id, cartItem));
    },
    UPDATE_CARTITEM(state, { cartItem }) {
        enhanceOrAdd(state.byId, cartItem.id, cartItem)
    },
    REMOVE_CARTITEM(state, { cartItem }) {
        Vue.delete(state.byId, cartItem.id);
    },
    UPDATE_GENERICITEMSUGGESTIONS(state, { suggestions }) {
        state.genericItemSuggestions = suggestions;
    },
};

export default {
    state,
    actions,
    mutations,
};
